// App.tsx
import React from 'react';
import Header from './components/SiteHeader';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Works from './pages/Works';
import ProductPage from './components/ProductPage';
import { DarkModeProvider } from './contexts/DarkModeContext';
import SiteFooter from './components/SiteFooter';
import AddonPage from './components/AddonPage';
import ScrollToTop from './components/ScrollToTop';
import About from './pages/About';
import AdultContentModal from './components/AdultContentModal';

const App: React.FC = () => {
    return (
        <DarkModeProvider>
            <AdultContentModal />
            <Router>
                <ScrollToTop />
                <Header />
                <div className="container mt-5">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/works" element={<Works />} />
                        <Route path="/works/:slug/:variationId?" element={<ProductPage />} />
                        <Route path="/addons/:slug" element={<AddonPage />} />
                    </Routes>
                </div>
                <SiteFooter />
            </Router>
        </DarkModeProvider>
    );
};

export default App;
